function PagingModule(moduleEle) {
  var module = this;
  module.moduleEle = moduleEle;
  module.initEvents = function () {
    //console.log('PagingModule initEvents()');
    module.moduleEle.on('click', 'a', function (e) {
      e.preventDefault();
      var link = cash(this),
        siblingLinks = link.closest('ul').find('a');
      siblingLinks.removeClass('clicked');
      link.addClass('clicked');
      //console.log('click', link.attr('href'));
      instant.list.fireOnChanged(module);
      return null;
    });
  }
  module.getModuleValue = function () {
    var href = module.moduleEle.find('.clicked').attr('href'),
      page = href ? window.getParameterFromLink('page', href) : null;
    //console.log('PagingModule.getModuleValue()', page);
    return { page: page ? parseInt(page) : null };
  }
  module.onServerSuccess = function (eventArgs) {
    module.moduleEle.html(eventArgs.response.data.PagingHtml);
  }
  module.initEvents();
}
//console.log('PagingModule', PagingModule);
instant.list.settings.moduleClasses['PagingModule'] = PagingModule;